module.exports = __webpack_public_path__ + "img/ic_infocenter.0c58bc1b.svg";